import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadService {

  public isLoading = new BehaviorSubject(true);
   
  constructor() { }
}
